<template>
  <div>
    <b-col class="mb-2">
      <div class="row">
        <div class="col-sm-8">&nbsp;</div>

        <div class="col-sm-4 text-right">
          <button
            class="btn btn-sm btn-success"
            type="button"
            @click="addtask()"
            :disabled="!CREATE"
          >
            Añadir nueva actividad
          </button>
        </div>
      </div>
    </b-col>

    <section
      class="without"
      v-if="!lstTasks.length > 0"
      style="margin-top: 60px"
    >
      <div class="row">
        <figure class="text-center">
          <img src="img/sin_datos.png" alt width="210px" />
        </figure>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <h1>Oops!</h1>
          <h4>
            No hay actividades
            <br />en para este deudor.
          </h4>
        </div>
      </div>
    </section>

    <section v-else>

      <b-table
        :hover="true"
        :striped="true"
        :bordered="false"
        :small="true"
        :fixed="false"
        responsive="sm"
        :items="lstTasks"
        :fields="fields_task"
        :current-page="currentPageTask"
        :per-page="perPage"
      >
        <!-- <template v-slot:cell(actions)="data"> -->
        <template slot="actions" slot-scope="data">
          <b-button
            size="sm"
            variant="primary"
            class="mr-1"
            title="ver"
            @click="viewtask(data.item)"
            :disabled="!READ"
          >
            <i class="fa fa-eye"></i>
          </b-button>

          <b-button
            size="sm"
            variant="success"
            class="mr-1"
            title="Editar"
            @click="edittask(data.item)"
            :disabled="!UPDATE"
          >
            <i class="fa fa-edit"></i>
          </b-button>

          <b-button
            size="sm"
            variant="danger"
            @click="deletetask(data.item.id)"
            title="Eliminar"
            :disabled="!DELETE"
          >
            <i class="fa fa-trash"></i>
          </b-button>
        </template>
      </b-table>
      <nav>
        <b-pagination
          size="sm"
          :total-rows="getRowCount(lstTasks)"
          :per-page="perPage"
          v-model="currentPageTask"
          prev-text="Anterior"
          next-text="Siguiente"
          align="right"
        />
      </nav>
    </section>

    <!-- MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
    <div class="modal fade" id="dlgActividad">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ACTIVIDAD</h4>
            <button type="button" class="close" @click="closetask()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="save()" method="post">
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row v-if="titulo">
                    <b-col sm="12">
                      <b-form-group>
                        <label>Cuenta</label>
                        <b-form-input
                          type="text"
                          v-model="titulo"
                          disabled="disabled"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtNombre">Nombre</label>
                        <b-form-input
                          type="text"
                          id="txtNombre"
                          v-model="task.name"
                          :disabled="disabled"
                        ></b-form-input>

                        <div
                          v-if="errors.name"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.name" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="task.status_id"
                          id="cmbEstado"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option :value="null" disabled
                              >-- Seleccione el estado --</option
                            >
                          </template>
                          <option
                            v-for="item in lstStatus"
                            :key="item.id"
                            :value="item.id"
                            >{{ item.name }}</option
                          >
                        </b-form-select>

                        <div
                          v-if="errors.status_id"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.status_id" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbTipoActividad">Tipo actividad</label>
                        <b-form-select
                          v-model="task.type"
                          id="cmbTipoActividad"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option :value="null" disabled
                              >-- Seleccione el tipo --</option
                            >
                          </template>
                          <option
                            v-for="item in lstType"
                            :key="item.id"
                            :value="item.id"
                            >{{ item.name }}</option
                          >
                        </b-form-select>

                        <div
                          v-if="errors.type"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.type" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <date-picker
                          id="txtFecha"
                          name="date"
                          v-model="task.date"
                          :config="options"
                          :disabled="disabled"
                        ></date-picker>

                        <div
                          v-if="errors.date"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.date" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbComercial">Responsable</label>
                        <b-form-select
                          id="cmbComercial"
                          v-model="task.staff_id"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option :value="null" disabled
                              >-- Seleccione una opción --</option
                            >
                          </template>
                          <option
                            v-for="item in lstStaffs"
                            :key="item.id"
                            :value="item.id"
                            >{{ item.name }} {{ item.last_name }} -
                            {{ item.type_name }}</option
                          >
                        </b-form-select>

                        <div
                          v-if="errors.staff_id"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.staff_id" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtComentario">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtComentario"
                          no-resize
                          v-model="task.task"
                          :disabled="disabled"
                        ></b-form-textarea>

                        <div
                          v-if="errors.task"
                          class="invalid-feedback d-block"
                        >
                          <div v-for="err in errors.task" :key="err">
                            {{ err }}
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="disabled == false">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabled"
                        >Guardar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
  </div>
</template>

<script>
export default {
  name: "taskJury",
  props: ["debtor_id"],
  data: () => {
    return {
      token: localStorage.getItem("token"),
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      lstTasks: [],
      lstStatus: [],
      lstType: [],
      lstStaffs: [],
      titulo: null,
      isEdit: false,
      disabled: false,
      dlgAct: "",
      task: {
        staff_id: null,
        process_id: null, // PENDIENTE
        name: null,
        task: null,
        date: null,
        type: null,
        private: "S",
        latitude: null, // PENDIENTE
        longitude: null, // PENDIENTE
        system: "N",
        status_id: null
      },
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true
      },
      datos: [],
      perPage: 10,
      currentPageTask: 1,
      errores: [],
      errors: {},
      // CABECERAS PARA LA TABLA DE LAS TASK
      fields_task: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },
        { key: "satatus_name", label: "Estado" },
        { key: "name", label: "Nombre" },
        { key: "type_name", label: "Tipo" },
        { key: "date", label: "Fecha" },
        { key: "staff_name", label: "Asignada a" },
        { key: "actions", label: "Opciones" },
      ],
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      auth: {},
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  created() {
    this.enabledActions();
    this.getTasks();
  },
  methods: {

    enabledActions() {
      this.auth = JSON.parse(localStorage.getItem("auth"))[0];
      this.CREATE = this.auth.create == 1;
      this.READ = this.auth.read == 1;
      this.UPDATE = this.auth.update == 1;
      this.DELETE = this.auth.delete == 1;
    },

    getTasks() {
      showLoader();
      // CARGAR EL LISTADO DE TAREAS O ACTIVIDADES DEL DEUDOR
      this.$http
        .get(`${this.$urlApi}tasks/debtor/${this.debtor_id}?token=${this.token}`)
        .then(
          response => {
            this.lstTasks = response.data.data;
          },
          error => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getRowCount(items) {
      return items.length;
    },

    initParameters() {
      showLoader();
      this.lstStaffs = [];

      // 5: LISTADO DE ESTADO DE LAS ACTIVIDADES O TAREAS
      this.$http.get(`${this.$urlApi}parameters/5?token=${this.token}`).then(
        response => {
          this.lstStatus = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // 22: LISTADO DE TIPOS DE ACTIVIDADES
      this.$http.get(`${this.$urlApi}parameters/22?token=${this.token}`).then(
        response => {
          this.lstType = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S
      this.$http.get(`${this.$urlApi}staffs/debtor/${this.debtor_id}?token=${this.token}`).then(
          response => {
            this.lstStaffs = response.data.data; // hacer un endpoint para que cargue estos staffs, enviar el id del deudor
            console.log(response.data.data);
            // response.data.data.forEach((item) => {
            //   if (item.role_id == 5 && item.id == this.auth.staff_id) this.lstStaffs.push(item);
            //   if (item.role_id == 9) this.lstStaffs.push(item);
            //   if (item.role_id == 1) this.lstStaffs.push(item);
            // });
          },
          error => {
            console.log(error);
          }
        );

      hideLoader();
    },
    addtask() {
      this.initParameters();
      this.task = {
        staff_id: this.role_id == 5 ? this.auth.staff_id : null,
        debtor_id: this.debtor_id,
        customer_id: null,
        date: null,
        process_id: 2, // JURÍDICO
        name: null,
        task: null,
        type: null,
        private: "S",
        latitude: null, // PENDIENTE
        longitude: null, // PENDIENTE
        system: "N",
        status_id: null
      };

      this.errores = [];
      $("#dlgActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // this.debtor_id = this.$route.params.id;
      $("#dlgActividad").modal("show");
    },
    closetask() {
      this.task = {
        staff_id: null,
        debtor_id: this.debtor_id,
        customer_id: null,
        date: null,
        process_id: 2, // JURÍDICO
        name: null,
        task: null,
        type: null,
        private: "S",
        latitude: null, // PENDIENTE
        longitude: null, // PENDIENTE
        system: "N",
        status_id: null
      };
      this.disabled = false;
      this.getTasks();
      $("#dlgActividad").modal("hide");
    },
    edittask(task) {
      showLoader();
      this.initParameters();
      this.isEdit = true;
      this.addResult = task.status_id != "13" ? true : false; // 13 : PLANIFICADA, SE ACTIVA SOLO PARA LAS ACTIVIDADES CANCELADAS O FINALIZADAS
      this.errores = [];
      $("#dlgActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.debtor_id = this.$route.params.id;
      this.task = Object.assign({}, task);
      hideLoader();
      $("#dlgActividad").modal("show");
    },
    viewtask(task) {
      showLoader();
      this.initParameters();
      $("#dlgActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.debtor_id = this.$route.params.id;
      this.task = Object.assign({}, task);
      this.disabled = true;
      hideLoader();
      $("#dlgActividad").modal("show");
    },
    deletetask(task_id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la actividad ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar"
      }).then(result => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}tasks/${task_id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" }
            })
            .then(function(response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Actividad eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar"
              }).then(result => {
                if (result.value) {
                  this.getTasks();
                }
              });
            })
            .catch(error => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    save() {
      if (this.isEdit) {
        this.updateTask();
      } else {
        this.storeTask();
      }
    },

    storeTask() {
      showLoader();

      this.errors = {};

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      this.task.url = `${location.origin}/#/debtors/view/${this.task.debtor_id}`;
      this.task.user_id = auth[0].id;

      this.datos = JSON.stringify(this.task);

      this.$http
        .post(`${this.$urlApi}tasks?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          // console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Actividad guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              this.task.staff_id = null;
              this.task.date = null;
              this.task.name = null;
              this.task.task = null;
              this.task.type = null;
              this.task.status_id = null;
              $("#dlgActividad").modal("hide");
              this.getTasks();
            }
          });
        })
        .catch(error => {
          this.errors = error;

          // console.log(error);
          this.errores = getMsgError(error);

          if (Array.isArray(this.errores)) {
            this.errors = this.errores[0];
          }

          console.log(this.errors);
          hideLoader();
        });
    },
    updateTask() {
      showLoader();

      this.errors = {};

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      this.task.url = `${location.origin}/#/debtors/view/${this.task.debtor_id}`;
      this.task.user_id = auth[0].id;

      this.datos = JSON.stringify(this.task);
      //console.log(this.datos)

      this.$http
        .put(
          `${this.$urlApi}tasks/${this.task.id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function(response) {
          console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Actividad actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              this.task.staff_id = null;
              this.task.date = null;
              this.task.name = null;
              this.task.task = null;
              this.task.type = null;
              this.task.status_id = null;
              $("#dlgActividad").modal("hide");
              this.getTasks();
            }
          });
        })
        .catch(error => {
          this.errores = getMsgError(error);

          if (Array.isArray(this.errores)) {
            this.errors = this.errores[0];
          }

          console.log(error);
          // this.errores = getMsgError(error);
          hideLoader();
        });
    }
  }
};
</script>
